export enum TagColor {
  Gold = 'gold',
  Red = 'red',
  Purple = 'purple',
  Default = 'default',
  Magenta = 'magenta',
}